import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { withRouter, useLocation } from "react-router-dom"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator"

import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { Col, Row } from "reactstrap"
import { useSelector, useDispatch } from "react-redux"

import {
  getOrders as onGetOrders,
  getOrdersSuccess,
} from "store/actions"

import Columns from "./Columns"

const InvoiceOrders = props => {
  const { orderObject, isOpen, handlerows } = props
  const dispatch = useDispatch()
  let location = useLocation()

  const { orders } = useSelector(state => ({
    orders: state.Orders.orders,
  }))

  const [invoiceOrders, setInvoiceOrders] = useState({ docs: [], totalDocs: 0 })
  
  const [selectedRows, setSelectedRows] = useState([])
  const [filter, setFilter] = useState({})
  const paginate = { size: 20, page: 1 }

  const [pageOptions, setPageOptions] = useState({
    sizePerPage: paginate.size,
    page: paginate.page,
    totalSize: 0,
    custom: true,
  })

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: (row, isSelect) => {
         setSelectedRows(prev => {
      const newRows = isSelect ? [...prev, row] : prev.filter(r => r._id !== row._id)
      
      // ✅ defer parent update to after render
      setTimeout(() => handlerows(newRows), 0)

      return newRows
    })
    },
    onSelectAll: (isSelect, rows) => {
      setSelectedRows(isSelect ? rows : [])
          setTimeout(() => handlerows(isSelect ? rows : []), 0)

    },
    selected: selectedRows.map(r => r._id),
  }

  useEffect(() => {
  handlerows(selectedRows)
}, [selectedRows, handlerows])
  // Fetch initial data
  useEffect(() => {
    if (
      !orders.hasOwnProperty("docs") &&
      invoiceOrders.docs?.length === 0 &&
      isOpen === true
    ) {
      const json = filterFunction(1)
      setFilter(json)
      dispatch(onGetOrders(json))
    }
    setInvoiceOrders(orders)

    if (orders?.docs) {
      setPageOptions({
        sizePerPage: orders.limit || paginate.size,
        page: orders.offset || paginate.page,
        totalSize: orders.totalDocs || 0,
        custom: true,
      })
    }
  }, [orders])

  // Clear when modal closed
  useEffect(() => {
    if (isOpen === false) {
      dispatch(getOrdersSuccess([]))
      setInvoiceOrders({ docs: [], totalDocs: 0 })
    }
  }, [isOpen])

  const node = useRef()

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  function filterFunction(page) {
    const queryParams = new URLSearchParams(location.search)

    const params = {
      userName: orderObject.userName,
      paymentStatus: false,
      delete: "false",
      orderStatus: "Done",
      ...filter,
    }

    for (let [key, value] of queryParams.entries()) {
      params[key] = value
    }

    params.page = page
    delete params.size

    return { params, paginate: { size: paginate.size, page } }
  }

  // Handle page change
  const handleTableChange = (type, { page, sizePerPage }) => {
    const json = filterFunction(page)
    json.paginate.size = sizePerPage
    dispatch(onGetOrders(json))
  }

  return (
    <React.Fragment>
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="_id"
        columns={Columns()}
        data={invoiceOrders.docs || []}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="_id"
            data={invoiceOrders.docs || []}
            columns={Columns()}
            bootstrap4
          >
            {toolkitProps => (
              <React.Fragment>
                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <BootstrapTable
                        remote={{ pagination: true }}
                        keyField="_id"
                        responsive
                        bordered={false}
                        striped={false}
                        defaultSorted={defaultSorted}
                        classes={
                          "table align-middle table-nowrap table-check"
                        }
                        headerWrapperClasses={"table-light"}
                        {...toolkitProps.baseProps}
                        {...paginationTableProps}
                        onTableChange={handleTableChange}
                        selectRow={selectRow}
                        
                        ref={node}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="align-items-md-center mt-3">
                  <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                    <PaginationListStandalone {...paginationProps} />
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    </React.Fragment>
  )
}

InvoiceOrders.propTypes = {
  orderObject: PropTypes.object,
  isOpen: PropTypes.bool,
  handlerows: PropTypes.func,
}

export default withRouter(InvoiceOrders)